import themeColors from '@/assets/theme/colors'
import { color } from 'framer-motion'

const classes = {
  appbarStyle: {
    background: '#fff', //`linear-gradient(135deg, ${themeColors.bg.start} 0%, ${themeColors.bg.end} 100%)`
    boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 2px 0px'
  },
  mainBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%'
  },
  linksBox: {
    display: 'flex',
    justifyContent: 'right',
    alignItems: 'center',
    marginRight: '30px'
  },
  logoBox: {
    marginTop: '5px'
  },
  flexBox: {
    display: 'flex',
    alignItems: 'center'
  },
  menuIcon: {
    cursor: 'pointer',
    color: themeColors.gray.mid,
    transform: 'scale(1.5)',
    '&:hover': {
      transform: 'scale(1.6)'
    }
  },
  langButton: {
    fontSize: 11,
    fontWeight: 400,
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.7
    },
    '&:active': {
      opacity: 0.85
    }
  },
  langButton2: {
    fontSize: 11,
    fontWeight: 400,
    marginLeft: '5px',
    marginRight: '5px',
    height: '23px'
  },
  typoLink: {
    textDecoration: 'none',
    fontSize: 12,
    color: '#fff',
    '&:hover': {
      opacity: 0.7
    },
    '&:active': {
      opacity: 0.85
    }
  },
  buttonRoot: {
    border: '0',
    boxShadow: 'none',
    '&:hover': {
      background: 'rgba(255, 255, 255, 0.2)'
    },
    color: themeColors.gray.mid,
    minHeight: 30,
    minWidth: 80
  },
  menuTitle: {
    margin: '0',
    textTransform: 'uppercase' as const,
    display: 'block',
    padding: '.5rem 1rem',
    whiteSpace: 'nowrap' as const,
    fontSize: 14,
    textAlign: 'center' as const,
    fontWeight: 600,
    color: themeColors.gray[800]
  },
  menuItem: {
    color: themeColors.gray[800]
  },
  dividerRoot: {
    height: '0',
    margin: '.5rem 0',
    overflow: 'hidden',
    borderTop: `1px solid ${themeColors.gray[200]}`
  }
}

export default classes
